import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';

import { Button } from 'ui-components/components/button';
import { FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';
import { noop } from 'ui-components/default-props/noop';

import { messages } from './messages';
import styles from './table-information.module.less';

/**
 * TableInformation component displays information about the table and provides a button to clear all items.
 * @param {object} props - The component props.
 * @param {number} [props.count] - The number of items in the table.
 * @param {() => void} [props.handleClearAll] - The function to call when the clear all button is clicked.
 * @param {object} [props.countInformationMessage] - The message to display for the count information.
 * @returns {JSX.Element} The TableInformation component.
 */
export const TableInformation = ({ count = 0, handleClearAll = noop, countInformationMessage = messages.defaultTableCount }) => {
  const hasTableItems = count > 0;

  return (
    <FlexRow className={styles['table-information']}>
      <Text formattedMessageValues={{ count }} textType={TextType.Caption} value={countInformationMessage} />
      {hasTableItems ? (
        <Button onClick={handleClearAll} theme='link'>
          <FlexRow>
            <FontAwesomeIcon icon={faXmark} />
            <Text textType={TextType.Caption} value={messages.clearAllButtonText} />
          </FlexRow>
        </Button>
      ) : null}
    </FlexRow>
  );
};
